import React from 'react'

import _ from 'lodash'

import WebPage from '@react/react-spectrum/Icon/WebPage'
import DevicePhone from '@react/react-spectrum/Icon/DevicePhone'
import DeviceDesktop from '@react/react-spectrum/Icon/DeviceDesktop'
import CCIcon from '@react/react-spectrum/Icon/CallCenter'
import ShoppingCart from '@react/react-spectrum/Icon/ShoppingCart'
import Branch3 from '@react/react-spectrum/Icon/Branch3'
import DataUser from '@react/react-spectrum/Icon/DataUser'
import DevicePreview from '@react/react-spectrum/Icon/DevicePreview'
import Chat from '@react/react-spectrum/Icon/Chat'
import Devices from '@react/react-spectrum/Icon/Devices'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Popover from '@react/react-spectrum/Popover'
import Button from '@react/react-spectrum/Button'
import { CHANNELS } from '../config/constants'

export const getTimelineIcon = (channel, ee) => {
  switch (channel.toLowerCase()) {
    case CHANNELS.AR:
      return <CustomOverlay channel={channel} ee={ee} icon={<DevicePreview />} />
    case CHANNELS.CALL_CENTER:
      return <CustomOverlay channel={channel} ee={ee} icon={<CCIcon />} />
    case CHANNELS.CHATBOT:
      return <CustomOverlay channel={channel} ee={ee} icon={<Chat />} />
    case CHANNELS.CRM:
      return <CustomOverlay channel={channel} ee={ee} icon={<DataUser />} />
    case CHANNELS.CX:
      return <CustomOverlay channel={channel} ee={ee} icon={<Devices />} />
    case CHANNELS.IOT:
      return <CustomOverlay channel={channel} ee={ee} icon={<Branch3 />} />
    case CHANNELS.MOBILE:
      return <CustomOverlay channel={channel} ee={ee} icon={<DevicePhone />} />
    case CHANNELS.STORE:
      return <CustomOverlay channel={channel} ee={ee} icon={<ShoppingCart />} />
    case CHANNELS.WEB:
      return <CustomOverlay channel={channel} ee={ee} icon={<WebPage />} />

    default:
      return <CustomOverlay channel={channel} ee={ee} icon={<DeviceDesktop />} />
  }
}

export const truncateWithEllipses = (text, max) => {
  return text.substr(0, max - 1) + (text.length > max ? '...' : '')
}
const CustomOverlay = ({ channel, ee, icon }) => {
  return (
    <OverlayTrigger placement='right'>
      <Button variant='tool' aria-label={channel} icon={icon} />
      <Popover title={`${channel} Event`} variant='default' role='tooltip' trapFocus={false}>
        <a
          href='#'
          onClick={(e) => {
            e.preventDefault()
            navigator.clipboard.writeText(JSON.stringify(ee))
          }}
        >
          copy json
        </a>
      </Popover>
    </OverlayTrigger>
  )
}

export const getProfileFieldValue = (tenantId, profile, path) => {
  if (path.match(/\d/) || !_.includes(path, '[]')) {
    return path
      .replace('$tenantId', tenantId)
      .split(' ')
      .map((pathPart) => _.get(profile.profile, pathPart, '--'))
      .join(' ')
  } else {
    var pathPart = _.get(profile.profile, _.split(path, '[]')[0])
    var ids = []
    _.forEach(pathPart, function (value) {
      ids.push(value.id)
    })
    return _.join(ids, ',')
  }
}
